import { AxiosInstance } from 'axios';
import { MediaSelectorRepository } from '~/model/repository/manager/tlnk/MediaSelectorRepository';

export default (Repository: AxiosInstance) => (): MediaSelectorRepository => ({
  create(body) {
    return Repository.post(`/memories-api/v1/admin/tlnk/media_selector/create_view_instance`, body);
  },
  list(body) {
    return Repository.post(`/memories-api/v1/admin/tlnk/media_selector/list_selected_media`, body);
  },
});
